export const ja_text: Record<string, string> = {
  "Sign in to your Lulu Loyal account to access all our features.":
    "Lulu Loyalアカウントにサインインして、すべての機能にアクセスしてください。",
  "Don't have an account?": "アカウントをお持ちでないですか？",
  "Click here to create one.": "こちらをクリックして作成してください。",
  "Create Lulu Loyal Account": "Lulu Loyalアカウントを作成",
  "Log In To Lulu Loyal": "Lulu Loyalにログイン",
  "Forgot Password?": "パスワードをお忘れですか？",
  "Delete Account": "アカウントを削除",
  "Confirm Delete": "削除を確認",
  "Are you sure you want to delete your account? This action cannot be undone and will cancel any active subscriptions.":
    "本当にアカウントを削除しますか？この操作は取り消せず、アクティブなサブスクリプションはすべてキャンセルされます。",
  "Delete Permanently": "完全に削除",
  "Confirm Logout": "ログアウトを確認",
  "Are you sure you want to logout?": "本当にログアウトしますか？",
  "Password Recovery": "パスワードの回復",
  "Enter your email address to receive a login link.":
    "ログインリンクを受け取るには、メールアドレスを入力してください。",
  "Send Recovery Email": "回復メールを送信",
  "Recovery email sent. Please check your inbox.":
    "回復メールが送信されました。受信箱を確認してください。",
  "Account updated successfully.": "アカウントが正常に更新されました。",
  "How Lulu Works": "Luluの仕組み",
  "100% untraceable": "100％追跡不可能",
  "Just share the username": "ユーザー名を共有するだけ",
  "No Login Required": "ログイン不要",
  "Invalid login link": "無効なログインリンク",
  "Signing you in...": "ログイン中...",
  Loading: "読み込み中",
  "Analyzing {username}": "{username}を分析中",
  seconds: "秒",
  "Figuring out who they follow": "誰をフォローしているか調べています",
  "Looking at who follows them": "誰が彼らをフォローしているか見ています",
  "Figuring out who's new": "誰が新しいか調べています",
  "Looking for suspicious profiles": "疑わしいプロフィールを探しています",
  "Taking a closer look": "詳しく見ています",
  "Looking through off-site content": "サイト外のコンテンツを調べています",
  "Analyzing behavior patterns": "行動パターンを分析しています",
  "Checking for red flags": "警告サインをチェックしています",
  "Wrapping up (this can take a while)": "完了中（時間がかかる場合があります）",
  "Finding stories": "ストーリーを探しています",
  "Loading story content": "ストーリーコンテンツを読み込み中",
  "Processing media": "メディアを処理中",
  "Preparing anonymous view": "匿名ビューを準備中",
  Finalizing: "最終処理中",
  "Email Address": "メールアドレス",
  Save: "保存",
  "@username": "@ユーザー名",
  "Reveal Follows": "フォローを表示",
  "Anonymously View Stories": "ストーリーを匿名で表示",
  "find red flags": "警告サインを見つける",
  "Best Results": "最高の結果",
  "Search over a billion accounts": "10億以上のアカウントを検索",
  "Is this legal?": "これは合法ですか？",
  "Lulu Loyal": "Lulu Loyal",
  LINKS: "リンク",
  "Why Use Lulu Loyal?": "なぜLulu Loyalを使うのか？",
  Prices: "価格",
  Resources: "リソース",
  LEGAL: "法的事項",
  "Privacy Policy": "プライバシーポリシー",
  "Terms of Use": "利用規約",
  "Refund Policy": "返金ポリシー",
  "CONTACT US": "お問い合わせ",
  "support@lululoyal.com": "support@lululoyal.com",
  "© 2025 Lulu Loyal. All Rights Reserved.":
    "© 2025 Lulu Loyal. 無断転載禁止。",
  "Manage Account": "アカウント管理",
  Login: "ログイン",
  Anonymity: "匿名性",
  "Secure + Untraceable": "安全 + 追跡不可能",
  "Security Risks": "セキュリティリスク",
  Pricing: "価格設定",
  "Lowest Prices": "最低価格",
  "Pretends to Be Free": "無料のふりをする",
  Speed: "速度",
  "Fastest + Best Results": "最速 + 最高の結果",
  "Slow + Poor Results": "遅い + 悪い結果",
  Quality: "品質",
  "Unmatched Accuracy": "他にない精度",
  "Consistent Errors": "一貫したエラー",
  Features: "機能",
  "Best Features": "最高の機能",
  "Limited Features": "限定機能",
  "Insta/TikTok/Snap": "Insta/TikTok/Snap",
  "All 3": "すべて3つ",
  "Only Instagram": "Instagramのみ",
  "Everyone Else": "その他全員",
  "🌶️ Porn account": "🌶️ アダルトアカウント",
  "🍒 Baddie": "🍒 セクシーな女性",
  "🍑 Spicy content": "🍑 刺激的なコンテンツ",
  "No Red Flags": "警告サインなし",
  "Follows back": "フォローバック",
  "No follow back": "フォローバックなし",
  "Subscribe to reveal all": "すべてを表示するには登録",
  "{number} new girls": "{number}人の新しい女の子",
  "{number} new guys": "{number}人の新しい男の子",
  "{number} Others": "{number}人その他",
  "Subscribe to Reveal All": "すべてを表示するには登録",
  "{number} RED FLAGS": "{number}個の警告サイン",
  "{number} SUS PROFILES": "{number}個の疑わしいプロフィール",
  "Updated {hours}h ago": "{hours}時間前に更新",
  "This account is private": "このアカウントは非公開です",
  "Notify Me": "通知する",
  "Reveal More": "もっと表示",
  "UPDATED {hours} HOURS AGO": "{hours}時間前に更新",
  "Stories from @{username}": "@{username}のストーリー",
  "Refresh Stories": "ストーリーを更新",
  "{number} STORIES": "{number}個のストーリー",
  "ANONYMOUS VIEWING": "匿名表示",
  "Subscribe to view": "表示するには登録",
  "User Not Found": "ユーザーが見つかりません",
  "Try Again": "もう一度試す",
  "Results for": "最新のフォローから:",
  "+{number} more": "+{number}人",
  "View All Recent Followers": "すべての最近のフォロワーを表示",
  "See Who They Followed": "誰をフォローしたかを見る",
  "Recent Follows": "最近のフォロー",
  "Recent Followers": "最近のフォロワー",
  "Thank You!": "ありがとうございます！",
  "Your subscription is now active.": "サブスクリプションが有効になりました。",
  "You now have full access to all Lulu Loyal features.":
    "Lulu Loyalのすべての機能に完全にアクセスできるようになりました。",
  "Start Analyzing": "分析を開始",
  "Create a Lulu Loyal account to access all our features.":
    "Lulu Loyalアカウントを作成して、すべての機能にアクセスしてください。",
  "If you have an account, ": "アカウントをお持ちの場合、",
  "you can login by clicking here.": "こちらをクリックしてログインできます。",
  "My Account": "マイアカウント",
  "Change Email Address": "メールアドレスを変更",
  "Change Password": "パスワードを変更",
  "Manage Subscription": "サブスクリプションを管理",
  "You are already subscribed": "すでに登録されています",
  "Account not found": "アカウントが見つかりません",
  "View All": "すべて表示",
  Girls: "女の子",
  Guys: "男の子",
  Other: "その他",
  All: "すべて",
  "Lulu Loyal's FAQ": "Lulu LoyalのFAQ",
  "PER WEEK": "週あたり",
  "Stop guessing, learn the truth, and reduce your anxiety levels with Lulu Loyal's tools.":
    "推測をやめて、真実を学び、Lulu Loyalのツールで不安レベルを減らしましょう。",
  "Unlimited access to all tools.": "すべてのツールへの無制限アクセス。",
  "No commitment, cancel any time.":
    "コミットメントなし、いつでもキャンセル可能。",
  "Free relationship anxiety guide.": "無料の恋愛不安ガイド。",
  "Get Unlimited Access": "無制限アクセスを取得",
  "User Reviews": "ユーザーレビュー",
  "Step 1 - Enter a Username": "ステップ1 - ユーザー名を入力",
  "Enter a username to start the search.":
    "ユーザー名を入力して検索を開始してください。",
  "Step 2 - Anonymous Search": "ステップ2 - 匿名検索",
  "Do an untraceable, anonymous search.": "追跡不可能な匿名検索を実行します。",
  "Step 3 - Best Results": "ステップ3 - 最高の結果",
  "Receive the best results, learn the truth.":
    "最高の結果を受け取り、真実を知りましょう。",
  "Instantly saw who my boyfriend had just followed! Got rid of soo much anxiety!":
    "彼氏がフォローした人がすぐに分かった！不安がかなり解消された！",
  "- Sophie": "- Sophie",
  "My ex was following Onlyfan models... like 4 of them 😭😭😭 At least I left him in time 🥲":
    "元カレがOnlyFansのモデルをフォローしてた…４人も😭😭😭でも早めに別れてよかった🥲",
  "- Osheb": "- Osheb",
  "I noticed my SO was following a bunch of new accounts very day... turns out it was nothing, good to check.":
    "パートナーが毎日新しいアカウントをたくさんフォローしているのに気づいた…結局何でもなかった、確認してよかった。",
  "- Anonymous": "- 匿名",
  "Most recent follow": "最新のフォロー",
  "Loyalty analysis": "忠誠度分析",
  "Can I trust these results?": "この結果を信頼できますか？",
  "Yes, our tech is best in class, and it's designed to be as accurate as possible. If you can't get the results you're looking for here, you can't get them anywhere. Our tech is the most advanced.":
    "はい、私たちの技術は最高クラスで、可能な限り正確になるよう設計されています。ここで探している結果が得られない場合、他のどこでも得られません。私たちの技術は最も進んでいます。",
  "Is this 100% anonymous?": "これは100％匿名ですか？",
  "Yes, there's no way anyone could ever know, or see that you've searched for a person. They'll also never know you've searched for them either. We've made that our top priority.":
    "はい、誰かを検索したことを誰かが知ったり見たりする可能性はありません。彼らもあなたが検索したことを知ることはありません。私たちはこれを最優先事項にしています。",
  "Can I catch cheaters with this?": "これで浮気を見つけられますか？",
  "Yes, many people have, and many people have stopped themselves landing in heartbreak. You can use Lulu Loyal to make sure you're not interacting with people who will mess you around.":
    "はい、多くの人がそうしていますし、多くの人が心の傷を避けることができました。Lulu Loyalを使って、あなたを傷つける人と関わらないようにできます。",
  "All the data we gather is public and it's 100% legal to collect this data, and to interact with this data too. You're not doing anything which breaks any law anywhere by searching for someone.":
    "私たちが収集するすべてのデータは公開されており、このデータを収集し、このデータとやり取りすることも100％合法です。誰かを検索することで、どこでも法律を破ることはありません。",
  "Why should I trust Lulu Loyal?": "なぜLulu Loyalを信頼すべきですか？",
  "Because we've been in your shoes, which is exactly why we built this product. What matters most to us, is to help other people find good people that won't mess them around.":
    "私たちもあなたと同じ立場にいたからこそ、この製品を作りました。私たちにとって最も重要なのは、他の人が自分を傷つけない良い人を見つけるのを助けることです。",
  "Unlimited Searches": "無制限検索",
  "Completely Anonymous": "完全匿名",
  "No Commitment. Cancel Anytime.": "契約なし。いつでもキャンセル可能。",
  "Easy to Cancel": "簡単にキャンセル",
  "Secured by Stripe Payments": "Stripe Paymentsで保護",
};
